module.exports = __webpack_public_path__ + "img/icon2-1.7bee07c5.png";